import type { Locale } from '@/i18n/locales'
import { routing } from '@/i18n/routing'

/*
 * The carrier guide's `/{locale}/carrier/…` namespace, parsed by structure alone: the
 * locale is a group this app declares, and the segments beneath are carried as written
 * (→ invariants.md#url-validity-is-the-stores-answer). The parse says only which paths
 * name a guide; who answers one is the request boundary's decision.
 */

export const CARRIER_SEGMENT = 'carrier'

export interface CarrierPath {
    readonly locale: Locale
    /** Beneath the `carrier` segment, as requested: none for the hub, one for a guide. */
    readonly segments: readonly string[]
}

/**
 * `/en-us/carrier/greyhound-bus-lines-139/` → `{ locale, segments }`, or `undefined` for
 * a path outside the namespace.
 */
export function carrierPath(pathname: string): CarrierPath | undefined {
    const [empty, locale = '', carrier = '', ...segments] = pathname.replace(/\/$/, '').split('/')
    if (empty !== '' || segments.includes('')) {
        return undefined
    }
    if (!(routing.locales as readonly string[]).includes(locale)) {
        return undefined
    }
    if (carrier !== CARRIER_SEGMENT) {
        return undefined
    }
    return { locale: locale as Locale, segments }
}

/** The guide's slug as the page type serves it (`greyhound-bus-lines-139`), or
 *  `undefined` for the hub or a deeper path. */
export function carrierGuideSlug({ segments }: CarrierPath): string | undefined {
    return segments.length === 1 ? segments[0] : undefined
}
